import { useState } from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CaseCard } from "../components/CaseCard";
import { CtaBand } from "../components/CtaBand";
import { Eyebrow } from "../components/Reveal";
import { THEMES, CASES } from "../data/content";

export default function Realisations() {
  const [filter, setFilter] = useState("all");
  const list = filter === "all" ? CASES : CASES.filter((c) => c.theme === filter);
  const chips = [["all", "Tous les métiers", "#3E3E3E"], ...THEMES.map((t) => [t.slug, t.name, t.color])];
  return (
    <div data-testid="references-page">
      <PageHero eyebrow="Réalisations · Références" color="#EE8445" title="Des projets structurés, exploités dans la durée." lead="Contexte, solution, résultat. Les noms de nos clients ne sont cités qu'avec leur accord." />
      <section className="mx-auto max-w-7xl px-5 lg:px-8 py-16 lg:py-24">
        <Eyebrow color="#EE8445">Références</Eyebrow>
        <div className="flex flex-wrap gap-2 mt-8 mb-12" data-testid="cases-filters">
          {chips.map(([k, label, color]) => (
            <button
              key={k}
              data-testid={`cases-filter-${k}`}
              onClick={() => setFilter(k)}
              className={`px-4 h-10 text-sm font-medium border transition-colors flex items-center gap-2 ${filter === k ? "text-white" : "bg-white text-ink border-ink/15 hover:border-ink/40"}`}
              style={filter === k ? { background: color, borderColor: color } : {}}
            >
              <span className="h-2 w-2" style={{ background: filter === k ? "#fff" : color }} />{label}
            </button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="cases-grid">
          {list.map((c, i) => <Reveal key={c.id} delay={(i % 3) * 0.06}><CaseCard c={c} /></Reveal>)}
        </div>
        {list.length === 0 && <p data-testid="cases-empty" className="text-ink/60">Aucune réalisation pour ce métier pour le moment.</p>}
      </section>
      <CtaBand color="#EE8445" title="Votre projet sera le prochain." />
    </div>
  );
}
